/**
 * @param {Object} localization
 * @param {string} key
 * @returns {string}
 */
export default function getLocalization(localization, key) {
    if (
        typeof localization === 'undefined' ||
        typeof localization[key] === 'undefined'
    ) {
        return key;
    }

    return localization[key];
}
